const isLoggedIn = () => {
  const email = localStorage.getItem('email');
  const password = localStorage.getItem('password');

  return email && password;
};

const getAuth = () => {
  return {
    username: localStorage.getItem('email'),
    password: localStorage.getItem('password'),
  }
};

const signOut = () => {
	localStorage.setItem('email', '');
    localStorage.setItem('password', '');
}

export default {
  getAuth,
  isLoggedIn,
  signOut
};